import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl } from '@mui/material';
import StoreSelect from '../../../../../Components/Forms/Store/StoreSelect.js';
import ArticleList from './ArticleList.js';
import ArticleCalendar from './ArticleCalendar.js';

const ArticlePicker = (props) => {
  const {
    subscriptionId,
    availableArticles,
    selectedArticleId,
    selectedArticleDate,
    onArticleClick,
    allowCalendarView,
    onLoadMore,
    hasMore,
    loadingMore
  } = props;

  const handleViewChange = (e) => {
    setSelectedView(e.target.value);
  };

  const { t } = useTranslation();

  const [selectedView, setSelectedView] = useState('list');

  const views = [{
    id: 'list',
    name: t('list-view')
  }, {
    id: 'cal',
    name: t('calendar-view')
  }];

  return (
    <>
      {
        (allowCalendarView) && (
          <FormControl margin='normal' required fullWidth>
            <StoreSelect
              id='view'
              required
              options={views}
              value={selectedView}
              onChange={handleViewChange}
            />
          </FormControl>
        )
      }
      {
        selectedView === 'list'
          ? (
            <ArticleList
              availableArticles={availableArticles}
              selectedArticleId={selectedArticleId}
              onArticleClick={onArticleClick}
              onLoadMore={onLoadMore}
              hasMore={hasMore}
              loadingMore={loadingMore}
            />
            )
          : (
            <ArticleCalendar
              subscriptionId={subscriptionId}
              availableArticles={availableArticles}
              selectedArticleId={selectedArticleId}
              selectedArticleDate={selectedArticleDate}
              onArticleClick={onArticleClick}
            />
            )
      }
    </>
  );
};

export default ArticlePicker;
